import React from "react";
import TopNavbar from "../components/TopNavbar";
import MainLinks from "../components/MainLinks";
import MainBlock from "../components/MainBlock";
import Footer from "../components/Footer";
import ChatvoltSupport from "../components/ChatvoltSupport";

const Home = () => (
  <div>
    <ChatvoltSupport />
    <TopNavbar />
    <MainLinks />
    <MainBlock />
    <Footer />
  </div>
);

export default Home;
